export default "__VITE_ASSET__DR95esf6__"